
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "../../store";
import { debugData } from "../../utils/debugData";
import { isEnvBrowser } from "../../utils/misc";
import { useSocketEventOutsideRequest } from "../../hooks/useSocketEventOutsideRequest";

import { UserState, SET_PLAYERDATA } from "../../reducers/userReducer";
import { PermissionType, PlayerType, HardMoneyState, SET_HOUSEDATA } from "../../reducers/hardmoneyReducer";
import { UIState, SET_activeTab, SET_hidden } from "../../reducers/uiReducer";

import moment from 'moment';

function getStatusColor(status: string): string {
    if (status === 'SUCCESS') {
      return 'lightgreen';
    } else if (status === 'PENDING') {
      return 'orange';
    } else {
      return 'red';
    }
}

const TransactionHistory: React.FC = () => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);
      
    return (
        <div
            className="flexCenter"
            style={{
                width: "100%",
                height: "100%",
                overflow: "auto",
                boxSizing: "border-box",
                position: "relative",
               
                //backgroundColor: "orange",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                //flexDirection: "column",
            }}
        >

            <div
                style={{
                    width: "100%",
                    height: "auto",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    gap: "1vh",
                    fontSize: "1.5vh",
                    fontWeight: "bold",
                    padding: "2vh",
                    borderRadius: "0.5vh",
                    border: "0.2vh solid rgba(90, 90, 90, 0.8)",
                    backgroundColor: "rgba(60, 60, 60, 0.8)",
                    color: "rgba(200, 200, 200, 1)",
                }}
            >
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        boxSizing: "border-box",
                        //backgroundColor: "gray",
                    }}
                >
                    <div
                        className="itemDiv"
                    >
                        CITIZEN NAME
                    </div>
                    <div
                        className="itemDiv"
                    >
                        CITIZEN ID
                    </div>
                    <div
                       className="itemDiv"
                    >
                        FEE AMOUNT
                    </div>
                    <div
                        className="itemDiv"
                    >
                        DATE
                    </div>
                    <div
                       className="itemDiv"
                    >
                        STATUS
                    </div>
                </div>
                {hardmoneyData.propertyMaintenance.map((transData, index) => {
                    const numericTimeInSeconds = moment(transData.paymentDate).unix();
                    const formattedDate = moment.unix(numericTimeInSeconds).format("M/D/YYYY");
                    
                    return (
                        <div
                            key={index}
                            style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                boxSizing: "border-box",
                                //backgroundColor: "gray",
                                //borderRadius: "0.25vh",
                            }}
                        >
                            <div
                                className="itemDiv"
                            >
                                {transData.playerFirstName} {transData.playerLastName}
                            </div>
                            <div
                                className="itemDiv"
                            >
                                {transData.UserStateID}
                            </div>
                            <div
                            className="itemDiv"
                            >
                                ${transData.amountPaid.toLocaleString("en-US")}
                            </div>
                            <div
                                className="itemDiv"
                            >
                                {formattedDate}
                            </div>
                            <div
                            className="itemDiv"
                                style={{
                                    color: getStatusColor(transData.status),
                                }}
                            >
                                {transData.status}
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    );
};

export default TransactionHistory;
